/**
 * EM 工作流任务处理通用View mixin
 *  提供常用组件的注册，路由状态，默认modelName
 *  routeHelper的混入
 *  以及一系列工作流完成任务的专有计算属性和方法
 *
 * Author YuJiaBei
 * Date 2020-07-12 08:14:36
 */
import EmViewTitle from "@/components/em/EmViewTitle";
import EmWorkflowProcessExecution from "@/components/em/EmWorkflow/ProcessExecution";
import EmWorkflowTaskComplete from "@/components/em/EmWorkflow/TaskComplete";
import EmWorkflowBusinessDataEditor from "@/components/em/EmWorkflow/BusinessDataEditor";
import EmButton from "@/components/em/EmButton";
import emRouteHelperMixin from "@/mixin/em/helper/route";

export default {
    mixins: [emRouteHelperMixin],
    components: {
        EmViewTitle,
        EmWorkflowProcessExecution,
        EmWorkflowTaskComplete,
        EmWorkflowBusinessDataEditor,
        EmButton
    },
    data() {
        return {
            $_getBusinessDataAtCurrentPage: false,
            $_needGoBack: false
        }
    },
    computed: {
        /**
         * 路由状态
         * default：list，默认只是查看
         * @returns {*}
         */
        $_emWorkflowTaskMixin_pathType() {
            return this.$_emRouterHelperMixin_pathType ? this.$_emRouterHelperMixin_pathType : 'list'
        },
        /**
         * 默认的modelName，因为mixin的合并规则可以允许覆写，这里就不采用$_命名规范了
         * @returns {default.computed.$_emRouterHelperMixin_entityName}
         */
        modelName() {
            return this.$_emRouterHelperMixin_entityName
        },
        modelStore() {
            return this.$store.state[this.modelName];
        },
        $_emWorkflowTaskMixin_processDefinitionKey() {
            return this.modelStore.processDefinitionKey
        },
        $_emWorkflowTaskMixin_businessData() {
            return this.modelStore.processBusinessData
        },
        $_emWorkflowTaskMixin_businessKey() {
            return this.$_emWorkflowTaskMixin_businessData.id
        },
        $_emWorkflowTaskMixin_applicationNo() {
            return this.$_emWorkflowTaskMixin_businessData.applicationNo
        },
        $_emWorkflowTaskMixin_callbackApi() {
            return this.modelStore.callbackApi
        },
        $_emWorkflowTaskMixin_isShowTaskComplete() {
            return this.$_emRouterHelperMixin_pathType === "todo"
        },
        $_emWorkflowTaskMixin_isEnableEdit() {
            //如果是待办,且当前任务状态允许修改，就返回true
            return this.$_emWorkflowTaskMixin_pathType
                && this.$_emWorkflowTaskMixin_pathType === "todo"
                && this.$_emWorkflowTaskMixin_businessData.processStatusAllowToModify
        },
        $_emWorkflowTaskMixin_taskId() {
            return this.$_emWorkflowTaskMixin_businessData
            && this.$_emWorkflowTaskMixin_businessData.hasOwnProperty('workflowTask')
            && this.$_emWorkflowTaskMixin_businessData.workflowTask
            && this.$_emWorkflowTaskMixin_businessData.workflowTask.hasOwnProperty('taskInstanceId')
                ? this.$_emWorkflowTaskMixin_businessData.workflowTask.taskInstanceId
                : ""
        }
    },
    beforeMount() {
        this.$_getBusinessDataAtCurrentPage = false;
        //如果businessData为空，即当前页刷新
        if (Object.keys(this.$_emWorkflowTaskMixin_businessData).length === 0) {
            //初始化businessData为空对象
            this.$_setBusinessData({});
            //存在business data id，执行查询
            if (this.$route.query.hasOwnProperty('id')) {
                this.$_getBusinessDataAtCurrentPage = true;
                this.$_getBusinessDataById();
            }
            //条件不足，返回上一页面
            else {
                this.$_needGoBack = true;
            }
        }
    },
    mounted() {
        //反之则认为从list页跳转
        if (this.$_getBusinessDataAtCurrentPage === false) {
            this.$_afterGetBusinessData();
        }
        if (this.$_needGoBack === true) {
            this.$message.error("页面所需信息不足，正在重新跳转...");
            setTimeout(() => this.$_emWorkflowTaskMixin_handleTaskCompleted(), 3000);
        }
    },
    methods: {
        $_emWorkflowTaskMixin_handleTaskCompleted() {
            this.$refs['emViewTitle'].goBack();
        },
        $_getBusinessDataById() {
            this.$store.dispatch('api/post', {
                url: this.modelStore.baseModuleUrl + "/" + this.modelName + "/workflow/find-by-query-form",
                data: {
                    idFilter: this.$route.query.id,
                    workflowQueryTypeFilter: this.$_emWorkflowTaskMixin_pathType
                }
            }).then((response) => {
                if (response.data.list.length > 0) {
                    this.$_setBusinessData(response.data.list[0]);
                    this.$_afterGetBusinessData();
                } else {
                    this.$_emWorkflowTaskMixin_handleTaskCompleted();
                }
            })
        },
        $_setBusinessData(obj) {
            this.$store.commit(this.modelName + "/setEntity", obj)
            this.$store.commit(this.modelName + "/setProcessBusinessData", JSON.parse(JSON.stringify(obj)))
        },
        $_afterGetBusinessData() {
            this.$nextTick(() => this.$store.commit('workflow/setProcessExecutionDoGet', true));
        }
    }
}
